var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Aviso"},[(_vm.scroll >= 88)?_c('div',{staticClass:"libe_home_nav"},[_c('headNav',{attrs:{"activeNav":'loan'}})],1):_vm._e(),_c('div',{staticClass:"eshoy_content_wrap"},[(_vm.scroll < 88 )?_c('div',{staticClass:"libe_homenav"},[_c('homeNav',{attrs:{"activeNav":'loan'}})],1):_vm._e()]),_c('footPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }